
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

var $4d657f824531b4cd$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('f3TU7'), JSON.parse("[\"f3TU7\",\"404.4065c030.js\",\"9BftR\",\"create-payload.ac460dac.js\",\"lM1L3\",\"create-post-interaction-log-payload.73c4cf2e.js\",\"knVBe\",\"segment-highlight.b13d0a23.js\",\"ak5E0\",\"dev.ded552d9.js\",\"1UKEw\",\"view.b8bffc4e.js\",\"7Q4ht\",\"view.557db1bb.js\",\"gFcxC\",\"view.74b26cde.js\",\"9WEDO\",\"view.0a064cfd.js\",\"h62UC\",\"language-selector.cf663f86.js\",\"evwwy\",\"language-selector.52185d53.js\",\"bNb0m\",\"language-selector.8f2f5a74.js\",\"hyT2F\",\"dropdown-import.fa3a2851.js\",\"PtGJI\",\"dropdown-import.d1b15d88.js\",\"b8kt6\",\"esm.80e45e89.js\",\"8QhO3\",\"app-switcher.ed5f26ad.js\",\"32DAP\",\"segment-highlight.0f740696.js\",\"78ssC\",\"robot-error.42b65db6.js\",\"3sxEO\",\"atlassian-switcher.0d815005.js\",\"jj9yd\",\"cs.42556323.js\",\"1JUTQ\",\"da.399a2c46.js\",\"eJY2b\",\"de.6d4e4245.js\",\"boveV\",\"en_GB.7761e241.js\",\"jhzZD\",\"en_ZZ.0d1c521f.js\",\"3ggHc\",\"en.148cccb0.js\",\"6K3IJ\",\"es.38ee5d63.js\",\"2Egxk\",\"et.9b06e447.js\",\"jrBrI\",\"fi.1fa46bb2.js\",\"ke1AQ\",\"fr.707f7411.js\",\"6THQG\",\"hu.9a02e64f.js\",\"h42BO\",\"is.9c634a96.js\",\"7ineD\",\"it.e9f9cccd.js\",\"9sO7N\",\"ja.bec383c9.js\",\"lnoMs\",\"ko.b2082d89.js\",\"kVmkq\",\"nb.468a8f48.js\",\"3DibN\",\"nl.7872b9c8.js\",\"9Uhkl\",\"pl.e2f34145.js\",\"8mFDW\",\"pt_BR.af201f23.js\",\"7GlIc\",\"pt_PT.32e154dd.js\",\"dvqQm\",\"ro.608d2eb9.js\",\"3ZtCq\",\"ru.0b8c7475.js\",\"dcHjQ\",\"sk.0f65108e.js\",\"ajnS3\",\"sv.1ed8aaeb.js\",\"bcnO6\",\"th.5dd575de.js\",\"hL42d\",\"tr.bf8ac923.js\",\"dr0Vi\",\"uk.78951171.js\",\"kopRi\",\"vi.587aade5.js\",\"dFq33\",\"zh_TW.db4a014c.js\",\"jMVsQ\",\"zh.6df05839.js\",\"iJGev\",\"jira-switcher.1eeacd7f.js\",\"5Sk5p\",\"jira-switcher.4eb1e833.js\",\"dRtpj\",\"animation-illustration.9535d565.js\",\"aitqo\",\"animation-illustration.b111b296.js\",\"cxGMB\",\"jira-switcher.8e16b500.js\",\"1az2W\",\"jira-switcher.35abbbfb.js\",\"dvcYi\",\"jira-switcher.runtime.301f4f77.js\",\"dvcYi\",\"jira-switcher.runtime.301f4f77.js\",\"2BPdX\",\"confluence-switcher.47781552.js\",\"1Cf3b\",\"generic-switcher.43e63b12.js\",\"9l0t7\",\"app-switcher.ba490676.js\"]"));


//# sourceMappingURL=404.runtime.1c56ff0d.js.map
